import ApplicationController from '../application_controller'

class AbilitiesController extends ApplicationController {
  static targets = ['readonly']

  connect () {
    this.handleReadOnly()
  }

  readonlySwitch (event) {
    this.handleReadOnly()

    if (event.target.checked) {
      const parent = document.querySelector(`input[value="${event.target.dataset.parent}"`)
      if (parent) {
        parent.checked = true
      }
    }
  }

  parentClick (event) {
    if (event.target.checked) { return }

    const parentName = event.target.value
    const child = document.querySelector(`input[data-parent="${parentName}"]`)
    if (!child) { return }

    child.checked = false
    this.handleReadOnly()
  }

  handleReadOnly () {
    const datevCheckBox = document.querySelector('input[value="datev"]')
    if (!datevCheckBox) { return }

    const someChecked = this.readonlyTargets.some(checkbox => checkbox.checked)
    if (someChecked) {
      datevCheckBox.checked = false
      datevCheckBox.disabled = true
    } else {
      datevCheckBox.disabled = false
    }
  }
}

export default AbilitiesController
